import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CheckIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 60" {...props}>
      <path
        fill={fill}
        d="M-1.46817915e-16,31.06199 C-0.00413793103,32.7108552 0.628965517,34.2578869 1.78344828,35.4185095 L24.422069,58.1803819 C26.8262069,60.5992755 30.7462069,60.6076453 33.1586207,58.2013065 L78.1958621,13.323437 C79.3544828,12.1683944 79.9958621,10.6241527 79.9986207,8.9738925 C80.0027586,7.32502732 79.3682759,5.77799561 78.2151724,4.61737308 L75.4317241,1.8190452 C73.0289655,-0.597058438 69.1103448,-0.60821827 66.6951724,1.79951549 L28.8331034,39.5267226 L13.3365517,23.9462021 C12.1310345,22.7339654 10.5448276,22.1285445 8.95724138,22.1285445 C7.38068966,22.1285445 5.80275862,22.7269905 4.59862069,23.9266724 L1.80275862,26.7138405 C0.644137931,27.8674881 0.00413793103,29.4117299 -1.46817915e-16,31.06199"
      />
    </Icon>
  );
};

CheckIcon.propTypes = {
  fill: PropTypes.string,
};

export default CheckIcon;
